var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0514 2.71643L14.4576 1.31018C15.0678 0.699991 16.0572 0.699991 16.6674 1.31018C17.2775 1.92038 17.2775 2.9097 16.6674 3.51989L4.69349 15.4938C4.25292 15.9343 3.70953 16.2582 3.11241 16.436L0.875 17.1025L1.54148 14.8651C1.71936 14.268 2.04321 13.7246 2.48377 13.2841L13.0514 2.71643ZM13.0514 2.71643L15.25 4.91503",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.e6abfb9ee5c30311b53ac88d4a2b6be3.svg";
export { ForwardRef as ReactComponent };